export default "/_next/static/images/3e87c1ac6194dec7982feb8acbb963da.png";